export default "__VITE_ASSET__CPXCSCIH__"